import TruncateText from './TruncateText';
import type { IProps as ITruncateTextProps } from './TruncateText';

export type { ITruncateTextProps };
export default TruncateText;
